<div class="cart-container font-inter">
    <div class="top-section-content">
        <div class="top-section container">
            <div class="icon-title-container">
                <mat-icon svgIcon="arrowleft" class="left-arrow-icon" (click)="goBack()"></mat-icon>
                <span class="title font-poppins">Shopping Cart</span>
            </div>
            <p class="subtitle">Discover amazing toy blocks and sets for endless creativity</p>
        </div>
    </div>

    <div class="bottom-container" [ngClass]="{ 'cart-empty': !loading && cartItems.length }">
        <mat-spinner *ngIf="loading" class="loading-spinner" [diameter]="70"></mat-spinner>
        @if (!loading && cartItems.length) {
        <div class="bottom-section-content">
            <div class="bottom-section container">
                <div class="bottom-left-section">
                    <div class="address-section">
                        @if (currentUserAddress) {
                        <div class="address-container">
                            <p>
                                Deliver to: <b>{{ currentUserAddress.name }}</b> {{ currentUserAddress.pincode }}
                            </p>
                            <p>
                                {{ currentUserAddress.address }}, {{ currentUserAddress.city }},
                                {{ currentUserAddress.state }}
                            </p>
                        </div>
                        } @else {
                        <div class="address-container">
                            <p class="no-address"><b>Check delivery time and services</b></p>
                        </div>
                        }
                        @if (!currentUserAddress) {
                            <button mat-stroked-button class="change-address-btn" (click)="addAddress()">Add Address</button>
                        }
                    </div>

                    <div class="items-count">
                        <div class="items-selected-container font-poppins">
                            <mat-checkbox
                                [checked]="isAllSelected()"
                                [indeterminate]="isSomeSelected()"
                                (change)="toggleSelectAll($event)"
                            >
                            </mat-checkbox>
                            <span>{{ selectedCartItems.size }}/{{ products.length }} Items Selected</span>
                        </div>

                        <div class="remove-move-container">
                            <span (click)="onClickMultipleCarts('remove')">Remove</span> |
                            <span (click)="onClickMultipleCarts('move')">Move To Wishlist</span>
                        </div>
                    </div>

                    <div class="items-container">
                        @for (item of products;let i = $index; track i) {
                        <div class="item">
                            <div class="image-container">
                                <img
                                    class="image"
                                    [class]="'product-image-gradient' + ((i % 3) + 1)"
                                    [src]="item.product.images.imagesUrl[0]"
                                    alt="Item Image"
                                    (click)="clickImage(item.product.id)"
                                />
                                <mat-checkbox
                                    class="item-checkbox"
                                    [checked]="isItemSelected(item)"
                                    (change)="toggleSelectCart(item)"
                                ></mat-checkbox>
                            </div>

                            @if (item.product.discountPercentage) {
                            <span class="offer-content">{{ item.product.discountPercentage }}% OFF</span>
                            }

                            <div class="item-info">
                                <div class="name-remove-container">
                                    <p class="item-name font-poppins" appEllipsis maxWidth="220px">
                                        {{ item.product.name }}
                                    </p>
                                    <p class="remove-container" (click)="onDeleteCartItem(item)">
                                        <mat-icon [svgIcon]="'delete'" class="remove-icon"></mat-icon>
                                        <span class="remove">Remove</span>
                                    </p>
                                </div>

                                @if (item.product.description) {
                                <p class="item-description" appEllipsis maxWidth="320px">
                                    {{ item.product.description }}
                                </p>
                                } @if ( item.product.category.includes(categories.BuyBlocks) ) {
                                <div
                                    class="block-item-info-container"
                                    *ngIf="item.product.category.includes(categories.BuyBlocks)"
                                >
                                    <div class="node-hole-plane-config">
                                        <div *ngIf="getFacesByType(item, 'Plane').length > 0" class="plane-config">
                                            <span class="block-face-label"
                                                >{{ "cart.shapeFacetype.plane" | translate }}:
                                            </span>
                                            <span class="block-face-value">{{
                                                getFacesByType(item, "Plane").join(", ")
                                            }}</span>
                                        </div>

                                        <div *ngIf="getFacesByType(item, 'Hole').length > 0" class="hole-config">
                                            <span class="block-face-label"
                                                >{{ "cart.shapeFacetype.hole" | translate }}:
                                            </span>
                                            <span class="block-face-value">{{
                                                getFacesByType(item, "Hole").join(", ")
                                            }}</span>
                                        </div>

                                        <div *ngIf="getFacesByType(item, 'Node').length > 0" class="node-config">
                                            <span class="block-face-label"
                                                >{{ "cart.shapeFacetype.node" | translate }}:
                                            </span>
                                            <span class="block-face-value">{{
                                                getFacesByType(item, "Node").join(", ")
                                            }}</span>
                                        </div>
                                    </div>

                                    <div class="color-config">
                                        <div class="color-title-section">
                                            <mat-icon [svgIcon]="'color'" class="color-icon"></mat-icon>
                                            <p class="color-title">Custom Color configuration</p>
                                        </div>

                                        <div class="color-info">
                                            <div *ngFor="let color of getFaceColors(item.singleBlockInfo?.color)">
                                                <div class="color-item">
                                                    <div class="color-name">
                                                        <span
                                                            class="color-box"
                                                            [ngStyle]="{
                                                                'background-color': getColorValue(color.value)
                                                            }"
                                                        ></span>
                                                        <span class="block-face-label">{{ color.key }} </span>
                                                    </div>
                                                    <div class="block-face-value">
                                                        {{ color.value }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                }

                                <div
                                    class="price-quantity-container"
                                    [ngClass]="{
                                        'custom-color-container': item.product.category.includes(categories.BuyBlocks)
                                    }"
                                >
                                    <div class="price-info">
                                        @if (item.product.discountedPrice) {
                                        <p class="discounted-price font-poppins">
                                            {{ item.product.discountedPrice | currency: "INR" }}
                                        </p>
                                        <p class="price font-inter">
                                            {{ item.product.price | currency: "INR" }}
                                        </p>
                                        } @else {
                                        <p class="discounted-price font-poppins">
                                            {{ item.product.price | currency: "INR" }}
                                        </p>
                                        }
                                    </div>

                                    <div class="quantity-container">
                                        <button
                                            (click)="onClick(-1, item.product.id, item.cartUUID!)"
                                            [disabled]="getProductQtyInCart(item.product.id, item.cartUUID!) <= 1"
                                            class="quantity-button"
                                        >
                                            <span class="quantity-icon">-</span>
                                        </button>
                                        <input
                                            type="number"
                                            id="quantity"
                                            [value]="getProductQtyInCart(item.product.id, item.cartUUID!)"
                                            (input)="onInputChange($event, item.product.id, item.cartUUID!)"
                                            (blur)="onBlur($event, item.product.id, item.cartUUID!)"
                                            name="quantity"
                                            class="quantity-input"
                                        />
                                        <button
                                            (click)="onClick(1, item.product.id, item.cartUUID!)"
                                            [disabled]="getProductQtyInCart(item.product.id, item.cartUUID!) >= 99"
                                            class="quantity-button"
                                        >
                                            <span class="quantity-icon">+</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }
                    </div>

                    <div class="wishlist-section">
                        <div class="wishlist-left-section">
                            <mat-icon [svgIcon]="'save'" class="save-icon"></mat-icon>
                            <span class="add-more">Add more from wishlist</span>
                        </div>

                        <div class="wishlist-right-section">
                            <a routerLink="/wishlist">
                                <mat-icon [svgIcon]="'greaterthan'" class="right-arrow-icon"></mat-icon>
                            </a>
                        </div>
                    </div>
                </div>

                <div class="bottom-right-section">
                    <div class="order-summary-section">
                        <p class="title font-poppins">Order Summary</p>
                        <div class="order-amount-section">
                            <div class="section">
                                <span class="label">Subtotal ({{ cartItems.length }} Items)</span>
                                <span class="value">{{ totalMRP | currency: "INR" }}</span>
                            </div>
                            <div class="section">
                                <span class="label">Discount</span>
                                <span class="value discount">{{ totalDiscount | currency: "INR" }}</span>
                            </div>

                            <div class="section">
                                <span class="label">Delivery Fee</span>
                                <span class="value delivery">Free</span>
                            </div>

                            <div class="separator"></div>

                            <div class="section total-section font-poppins">
                                <span class="total">Total Amount</span>
                                <span class="total-value">{{ totalAmount | currency: "INR" }}</span>
                            </div>
                        </div>

                        <div class="saving-section">
                            <div class="icon-container">
                                <mat-icon [svgIcon]="'tick'" class="saving-icon"></mat-icon>
                            </div>
                            <span class="saving-text"
                                >You're saving {{ totalMRP - totalAmount | currency: "INR" }} on this order!</span
                            >
                        </div>

                        <button
                            mat-stroked-button
                            class="checkout-button font-poppins"
                            (click)="onCheckout()"
                            [disabled]="!currentUserAddress || !isCheckoutEnabled"
                        >
                            <span class="button-text">Proceed to Checkout</span>
                            <mat-icon [svgIcon]="'rightarrow'" iconPositionEnd class="checkout-icon"></mat-icon>
                        </button>

                        <button
                            mat-stroked-button
                            class="continue-shopping-button font-poppins"
                            (click)="onNavigateToProductPage()"
                        >
                            <mat-icon [svgIcon]="'cart'" class="cart-icon"></mat-icon>
                            <span class="button-text">Continue Shopping</span>
                        </button>

                        <div class="secure-section">
                            <div class="section">
                                <mat-icon [svgIcon]="'safematerial'" class="secure-icon"></mat-icon>
                                <span class="secure-text">100% Secure Payments</span>
                            </div>
                            <div class="section">
                                <mat-icon [svgIcon]="'freedelivery'" class="secure-icon"></mat-icon>
                                <span class="secure-text"
                                    >Free Delivery on orders above {{ freeDeliveryAmount | currency: "INR" }}</span
                                >
                            </div>
                            <div class="section">
                                <mat-icon [svgIcon]="'return'" class="secure-icon"></mat-icon>
                                <span class="secure-text">Easy 7-day Returns</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="suggestion-section-content">
            <div class="suggestion-section container">
                <p class="suggestion-title font-poppins">You might also like</p>

                <div class="suggestion-container">
                    @for (item of suggestedProducts;let i = $index; track i) {
                    <div class="suggestion-item">
                        <div class="suggestion-image-container">
                            <img
                                class="image"
                                [class]="'product-image-gradient' + ((i % 3) + 1)"
                                [src]="item.images.imagesUrl[0]"
                                alt="Item Image"
                                (click)="clickImage(item.id)"
                            />

                            <button
                                mat-icon-button
                                class="wishlist-button icon-button-overlay-remove"
                                (click)="toogleFavorite(item)"
                            >
                                @if (isInWishlist(item)) {
                                <mat-icon [svgIcon]="'activewishlist'"></mat-icon>
                                } @else {
                                <mat-icon [svgIcon]="'wishlist'" class="wishlist-icon"></mat-icon>
                                }
                            </button>
                        </div>

                        <div class="suggestion-info">
                            <p class="suggestion-name font-poppins" appEllipsis maxWidth="200px">
                                {{ item.name }}
                            </p>
                            <div class="price-info">
                                <p class="suggestion-price">
                                    {{ item.discountedPrice | currency: "INR" }}
                                </p>
                                <p class="suggestion-original-price">
                                    {{ item.price | currency: "INR" }}
                                </p>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </div>
        </div>
        } @else if(!loading && !cartItems.length) {
        <div class="no-cart-container font-poppins">
            <div class="circle">
                <mat-icon [svgIcon]="'search'" class="search-icon"></mat-icon>
                <mat-icon [svgIcon]="'empty'" class="empty-icon"></mat-icon>
            </div>

            <div class="message-container">
                <p class="title">Hey, it feels so light!</p>

                <p class="subtitle">There is nothing in your cart. Let's add some items.</p>

                <button mat-stroked-button class="empty-button" routerLink="/wishlist">
                    <mat-icon [svgIcon]="'arrowleft'" class="checkout-icon"></mat-icon>
                    ADD ITEMS FROM WISHLIST
                </button>
            </div>
        </div>
        }
    </div>
</div>
